import { BaseService } from './base-service';
import { KimMhoReportMapper } from '@/core/mappers/kim-mho-report';
import type { KimMHO } from '@/types/KimMHO';
import type {
	GetKimMHOReportResponseDTO,
	GetKimMHOReportRequestDTO,
} from '@/core/dto/kim-mho';

export interface GetKimMHOReportByFileIdRequestDTO {
	file_id: string;
	company_id: string;
	organization_id: string;
}

export class KimMHOReportService extends BaseService<any> {
	private static instance: KimMHOReportService;

	private constructor(public readonly basePath: string = '/ergonomic-tool/kim-mho') {
		super();
	}

	public static getInstance(): KimMHOReportService {
		if (!KimMHOReportService.instance) {
			KimMHOReportService.instance = new KimMHOReportService();
		}
		return KimMHOReportService.instance;
	}

	public async getReport(params: GetKimMHOReportRequestDTO): Promise<KimMHO> {
		const url = this.basePath + `/by-id/${params.id}`;
		const { data } = await this.getInstance().get<GetKimMHOReportResponseDTO>(url, { params });
		return new KimMhoReportMapper(data).toDomain();
	}

	public async getReportByFileId(params: GetKimMHOReportByFileIdRequestDTO): Promise<KimMHO> {
		const url = this.basePath + `/${params.file_id}`;
		const { data } = await this.getInstance().get<GetKimMHOReportResponseDTO>(url, { params });
		return new KimMhoReportMapper(data).toDomain();
	}
}

